import React, { useState, useEffect } from 'react';
import {
  CFormTextarea, CFormCheck, CButton,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
} from '@coreui/react';
import Accordions from '../../components/shared/Accordians';
import Select from 'react-select';
import AssesmentPlanSuggestion from './AssesmentPlanSuggestion';

let pathId = 0;

const normalizeLinkedQuestion = (linkedQuestion) => {
  // Ensure linkedQuestion is always an array
  if (!linkedQuestion) return [];
  return Array.isArray(linkedQuestion) ? linkedQuestion : [linkedQuestion];
};

const generatePaths = (options, currentPath = [], currentQuestion = { id: '', label: '' }, flow = []) => {
  let paths = [];

  options.forEach((option) => {
    const newFlow = [...flow, { questionId: currentQuestion.id, optionId: option.id, label: option.label }];

    const newPath = {
      id: ++pathId,
      path: [...currentPath, `${currentQuestion.label}:${option.label}`],
      flow: newFlow,
    };
    paths.push(newPath);

    // Normalize and handle linkedQuestion recursively
    const normalizedLinkedQuestions = normalizeLinkedQuestion(option.linkedQuestion);

    normalizedLinkedQuestions.forEach((linked) => {
      if (linked.options) {
        paths = paths.concat(
          generatePaths(
            linked.options,
            newPath.path,
            { id: linked.id, label: linked.label },
            newFlow
          )
        );
      }
    });
  });
  return paths;
};



const updateLastOption = (inputData, keyPath, key, value) => {
  // Recursive traversal to locate the last option in keyPath

  const traverse = (options, path) => {
    if (path.length === 0) return options;

    const currentKey = path[0];
    const remainingPath = path.slice(1);

    const option = options.find((opt) => opt.id === currentKey.optionId);

    if (!option) {
      console.error(`Key not found in path: ${currentKey}`);
      return null;
    }

    // Normalize linkedQuestion and continue traversal
    const normalizedLinkedQuestions = normalizeLinkedQuestion(option.linkedQuestion);

    if (remainingPath.length === 0) {
      return option; // Target option reached
    }

    if (normalizedLinkedQuestions.length > 0) {
      return traverse(normalizedLinkedQuestions.flatMap((linked) => linked.options || []), remainingPath);
    }

    console.error(`Invalid path at: ${currentKey}`);
    return null;
  };


  const optionsClone = [...inputData.options];
  const lastOption = traverse(optionsClone, keyPath);

  if (lastOption) {
    lastOption[key] = value; // Update the target option
  } else {
    console.error("Failed to locate the target option in the keyPath.");
  }

  return { ...inputData, options: optionsClone };
};

const QuestionDropdownTSTab = ({ options, dropdownInput, setDropdownInput, labList, medicationData, imagingData, diagnosiss, diagnosisForNested, addFormMade, handleAutoSave }) => {
  const [combinations, setCombinations] = useState([]);
  const [linkModel, setLinkModel] = useState(false);
  const [linkData, setLinkData] = useState(null);
  const [comboData, setComboData] = useState(null)
  const [currentLinkData, setCurrentLinkData] = useState(null)

  const findOptionByFlow = (options, flow) => {

    if (!options || flow.length === 0) return null; // Base case

    const { questionId, optionId } = flow[0]; // Take the first flow step
    const remainingFlow = flow.slice(1); // Remaining steps

    // Find the option that matches the current questionId and optionId
    const option = options.find((opt) => opt.id === optionId);

    if (!option) {
      console.error(`Option not found for questionId: ${questionId}, optionId: ${optionId}`);
      return null;
    }


    if (remainingFlow.length === 0) {
      return option;
    }

    console.log("Option found======>", option);
    if (option.linkedQuestion && !Array.isArray(option.linkedQuestion)) {        ///added to convert
      option.linkedQuestion = [option.linkedQuestion];
    }
    if (option.linkedQuestion && Array.isArray(option.linkedQuestion)) {
      return option.linkedQuestion
        .map((linked) => findOptionByFlow(linked.options, remainingFlow))
        .find((result) => result !== null);
    }

    return null;
  };



  useEffect(() => {
    if (dropdownInput.options?.length > 0) {
      const paths = generatePaths(dropdownInput.options, [], dropdownInput);
      setCombinations(paths);

    }
  }, [dropdownInput]);



  const updateOption = (idx, key, value, keyPath = null, path) => {
    const deepClone = (obj) => JSON.parse(JSON.stringify(obj)); // Deep clone to avoid mutations

    // Recursive function to locate and update the target option
    const traverseAndUpdate = (options, path) => {

      console.log(path)
      if (!options || path.length === 0) return;
      // console.log("tranverse And Update 2")
      const [currentStep, ...remainingPath] = path;

      const targetOption = options.find((opt) => opt.id === currentStep.optionId);
      // console.log("targert======>", targetOption)

      if (!targetOption) {
        console.error(`Option not found at step: ${currentStep.optionId}`);
        return;
      }

      // If we are at the last step, update the key-value pair
      if (remainingPath.length === 0) {

        targetOption[key] = value;

        return;
      }

      // Continue traversing linkedQuestion, ensuring it is a list

      const normalizedLinkedQuestions = normalizeLinkedQuestion(targetOption.linkedQuestion);
      console.log("*****************************************", normalizedLinkedQuestions)
      normalizedLinkedQuestions.forEach((linked) => {

        if (linked.options) {
          traverseAndUpdate(linked.options, remainingPath);
        }
      });
    };



    const updatedDropdown = deepClone(dropdownInput); // Deep clone the state


    if (path) {
      traverseAndUpdate(updatedDropdown.options, path); // Update target option
    } else {
      updatedDropdown.options[idx] = { ...updatedDropdown.options[idx], [key]: value }; // Root-level update
    }

    setDropdownInput(updatedDropdown); // Save the updated state
  };
  console.log("updatedDropdown=============>", dropdownInput)


  const renderSelectionWithReason = (title, data, selectedItems, idx, key, keyPath, path) => (
    <div className="mt-3">
      <p className="font-weight-medium mb-2">{title}</p>

      <Select
        className="w-full rounded"
        placeholder={`Select ${title}`}
        isMulti
        options={data.map((item) => ({
          value: item.id || item.ID,
          label: item.name || item.LabName || item.Name
        }))}
        value={selectedItems} // Ensure this reflects the current selection
        onChange={(selectedOptions) => saveSelectionWithReason(selectedOptions, title, idx, key, keyPath, path)}
      />
      {selectedItems?.map((item, itemIdx) => (
        <div key={itemIdx} className="mt-2">
          <p className="font-weight-medium mb-2">Reason for {item.label}</p>
          <CFormTextarea
            value={item.reason || ''}
            onChange={(e) =>
              saveReasonForItem(selectedItems, idx, key, title, itemIdx, e.target.value, keyPath, path)
            }
            placeholder={`Enter reason for ${item.label}`}
          />
        </div>
      ))}
    </div>
  );

  const saveSelectionWithReason = (selectedOptions, title, idx, key, keyPath, path) => {
    const itemsWithReason = selectedOptions.map((option) => ({
      value: option.value,
      label: option.label,
      reason: option?.reason || '',
    }));

    const existingDropdown = JSON.parse(JSON.stringify(dropdownInput));

    const currentOptions = path.reduce((acc, step, index) => {
      const option = acc.find((opt) => opt.id === step.optionId);

      if (!option) {
        console.error(`Option not found for step: ${JSON.stringify(step)}`);
        return acc;
      }

      if (index === path.length - 1) {
        return option?.linkedQuestion?.options || acc;
      }
      if (option.linkedQuestion && !Array.isArray(option.linkedQuestion)) {        ///added to convert
        option.linkedQuestion = [option.linkedQuestion];
      }
      if (option.linkedQuestion && Array.isArray(option.linkedQuestion)) {
        const linkedOptions = option.linkedQuestion
          .flatMap((linked) => linked.options || [])
          .filter((opt) => opt);
        return linkedOptions.length > 0 ? linkedOptions : acc;
      }

      return acc;
    }, existingDropdown.options);

    const targetOption = currentOptions.find((opt) => opt.id === keyPath[keyPath.length - 1]);
    console.log("Target option", targetOption);

    if (targetOption) {

      const existingOrders = targetOption[key] || {};
      const updatedOrders = {
        ...existingOrders,
        [title.toLowerCase()]: itemsWithReason,
      };


      targetOption[key] = updatedOrders;

      setDropdownInput(existingDropdown);
      console.log("Updated dropdown input", existingDropdown);
    } else {
      console.error("Failed to locate the target option for the given keyPath and path.");
    }
  };

  const saveReasonForItem = (selectedItems, idx, key, title, itemIdx, newReason, keyPath, path) => {

    const updatedItems = selectedItems.map((current, i) =>
      i === itemIdx ? { ...current, reason: newReason } : current);

    const existingDropdown = JSON.parse(JSON.stringify(dropdownInput));

    const currentOptions = path.reduce((acc, step, index) => {
      const option = acc.find((opt) => opt.id === step.optionId);
      if (!option) {
        console.error(`Option not found for step: ${JSON.stringify(step)}`);
        return acc;
      }

      if (index === path.length - 1) {
        return option?.linkedQuestion?.options || acc;
      }

      if (option.linkedQuestion && Array.isArray(option.linkedQuestion)) {
        const linkedOptions = option.linkedQuestion
          .flatMap((linked) => linked.options || [])
          .filter((opt) => opt);
        return linkedOptions.length > 0 ? linkedOptions : acc;
      }

      return acc;
    }, existingDropdown.options);


    const targetOption = currentOptions.find((opt) => opt.id === keyPath[keyPath.length - 1]);


    if (targetOption) {

      const existingOrders = targetOption[key] || {};
      const updatedOrders = {
        ...existingOrders,
        [title.toLowerCase()]: updatedItems,
      };
      targetOption[key] = updatedOrders;

      setDropdownInput(existingDropdown);
      console.log("Updated dropdown input", existingDropdown);
    } else {
      console.error("Failed to locate the target option for the given keyPath and path.");
    }
  };

  const handleAssessment = (idx, key, keyPath, path, updateOption) => {
    setComboData({ idx, key, keyPath, path, updateOption });
    setLinkModel(true)
  }

  useEffect(() => {
    if (linkData && linkData.length > 0) {
      updateOption(comboData.idx, comboData.key, linkData, comboData.keyPath, comboData.path)
      setLinkData(null)
    }
  }, [linkData])

  // console.log("Updated dropdown link data", linkData)
  return (
    <div className="question-dropdown-ts-tab m-3" style={{   borderRadius: '10px' }}>
      <div className="d-flex flex-column gap-2">
        {combinations.map((combination, idx) => {
          const combinationKey = combination.path.join(' > ');
          const option = findOptionByFlow(dropdownInput.options, combination.flow) || {};
          return (
            <div key={idx} style={{  borderRadius: '10px' }} className="shadow-ex">

              <Accordions
                linkQuestion={false}
                title={`${combinationKey}`}
                content={
                  <div>
                    {/* <CFormCheck
                      className="mt-2"
                      onChange={() => {
                        console.log("_---------------------------------")

                      }}

                      checked={option.showInAssessment || false}
                      label="Link Assessment?"
                    /> */}

                    <CButton variant='outline' color='info'
                      style={{
                        borderRadius: '5px',
                        padding: '5px 10px',
                        fontSize: '12px',
                        margin: '0 10px',
                        fontWeight: 'medium',

                      }}
                      onClick={() => {
                        const keyPath = combination.flow.map((step) => step.optionId);
                        const path = combination.flow.map((step) => step)
                        if (option?.linkedAssessment && option.linkedAssessment.length > 0) {
                          updateOption(idx, 'showInAssessment', true, keyPath, path);
                          updateOption(idx, 'attachOrders', true, keyPath, path);
                        } else {
                          updateOption(idx, 'showInAssessment', false, keyPath, path);
                          updateOption(idx, 'attachOrders', false, keyPath, path);
                        }
                        handleAssessment(idx, 'linkedAssessment', keyPath, path, option?.showInAssessment)
                        setCurrentLinkData(option?.linkedAssessment)
                      }} >Link Assessment</CButton>



                    {/* {option.showInAssessment && (
                      <div className="w-100 d-flex flex-column ps-3 mt-3">
                        <p className="font-weight-medium mb-2">Assessment</p>
                        <CFormTextarea
                          rows={3}
                          value={option.remark || ''}
                          onChange={(e) => {
                            const keyPath = combination.flow.map((step) => step.optionId);
                            const path = combination.flow.map((step) => step);
                            updateOption(idx, 'remark', e.target.value, keyPath, path);
                          }}
                          placeholder=""
                        />
                      </div>
                    )} */}
                    {/* <CFormCheck
                      className="mt-3"
                      onChange={(e) => {
                        const keyPath = combination.flow.map((step) => step.optionId);
                        const path = combination.flow.map((step) => step);
                        updateOption(idx, 'attachOrders', !option.attachOrders, keyPath, path);
                      }}

                      checked={option.attachOrders || false}
                      label="Link Order for Plan?"
                    /> */}
                    {/* {option.attachOrders && (

                      <div style={{ background: '#f2f2f2', borderRadius: '10px' }} className="shadow-ex p-2 mt-4">
                        {renderSelectionWithReason(
                          'Lab',
                          labList,
                          option.orders?.lab,
                          idx,
                          'orders',
                          combination.flow.map((step) => step.optionId),
                          combination.flow.map((step) => step)
                        )}
                        {renderSelectionWithReason(
                          'Medication',
                          medicationData,
                          option.orders?.medication,
                          idx,
                          'orders',
                          combination.flow.map((step) => step.optionId),
                          combination.flow.map((step) => step)
                        )}
                        {renderSelectionWithReason(
                          'Imaging',
                          imagingData,
                          option.orders?.imaging,
                          idx,
                          'orders',
                          combination.flow.map((step) => step.optionId),
                          combination.flow.map((step) => step)
                        )}
                        <div className="w-100 mt-3">
                          <p className="font-weight-medium mb-2">Order Suggestion</p>
                          <CFormTextarea
                            value={option.orders?.providerSuggestion || ''}
                            onChange={(e) => {
                              const keyPath = combination.flow.map((step) => step.optionId);
                              const path = combination.flow.map((step) => step);
                              updateOption(idx, 'orders', { ...option.orders, providerSuggestion: e.target.value }, keyPath, path);
                            }}
                            placeholder="Enter provider suggestion here..."
                          />
                        </div>
                      </div>
                    )} */}



                    <CFormCheck
                      className="mt-3"
                      onChange={() => {
                        const keyPath = combination.flow.map((step) => step.optionId);
                        const path = combination.flow.map((step) => step);
                        updateOption(idx, 'suggestDiagnosis', !option?.suggestDiagnosis, keyPath, path);
                      }}
                      id={`isShowIn${idx}`}
                      checked={option?.suggestDiagnosis || false}
                      label="Suggested Diagnosis?"
                    />
                    {option?.suggestDiagnosis && (
                      <div style={{ background: '#f2f2f2', borderRadius: "10px" }} className='shadow-ex p-2 mt-4'>

                        <div>
                          <p className="font-weight-medium mb-2 pt-2">Diagnosis</p>
                          <Select
                            className="w-full rounded"
                            placeholder="Select Diagnosis"
                            isMulti
                            options={diagnosisForNested || diagnosiss}
                            value={option?.diagnosis}
                            onChange={(selectedOptions) => {
                              const selectedDiagnosis = selectedOptions.map((option) => ({
                                value: option.value,
                                label: option.label,
                              }));
                              const path = combination.flow.map((step) => step);
                              updateOption(idx, 'diagnosis', selectedDiagnosis, null, path);
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                }
                dropdownInput={dropdownInput}
                setDropdownInput={setDropdownInput}
                idx={idx}
                key={idx}
              />
            </div>
          );
        })}
      </div>
      <div>

        {/* {linkModel &&  } */}
        <CModal
          size='xl'
          visible={linkModel}
        >
          <CModalBody>
            <AssesmentPlanSuggestion LinkFor='HPI' setLinkData={setLinkData} setLinkModel={setLinkModel} linkData={currentLinkData} closeEditModel={() => setLinkModel(false)} addFormMade={handleAutoSave} />
          </CModalBody>

        </CModal>
      </div>
    </div>
  );
};

export default QuestionDropdownTSTab;